const paths = {
    PREVIEW: '/preview/',
    LOGIN: '/login',
    START_WITH_BOOK: '/start-with-book',
    RESET_PASSWORD: '/reset-password',
    INTRO: '/intro',
};

export default paths;
